import { useEffect, useRef, useContext } from 'preact/hooks';
import { ChatContext } from './context.js';

export function useAnalytics() {
  const { analytics, session } = useContext(ChatContext);
  const beaconFiredRef = useRef(false);

  useEffect(() => {
    const onPageHide = () => {
      if (beaconFiredRef.current) return;
      beaconFiredRef.current = true;
      analytics?.endSession(location.href, true);
    };

    const onVisibilityChange = () => {
      if (document.visibilityState === 'hidden') onPageHide();
    };

    document.addEventListener('visibilitychange', onVisibilityChange);
    window.addEventListener('pagehide', onPageHide);

    return () => {
      document.removeEventListener('visibilitychange', onVisibilityChange);
      window.removeEventListener('pagehide', onPageHide);
      if (!beaconFiredRef.current) analytics?.endSession(location.href);
    };
  }, [analytics]);

  return null;
}
